<section 
  *ngIf="html" 
  class="page-container" 
  [innerHTML]="html | safe:'html'"
>
</section>
